import React from 'react'
import { Link } from 'gatsby'

import { LocaleContext } from './languageContext'
import PageContext from '../components/pageContext'

const LocalizedLink = ({ to, ...props }) => (
  <PageContext.Consumer>{({ languages }) =>
    <LocaleContext.Consumer>
      {({ locale }) => {
        const path = languages[locale] ? to : `/${locale}${to}`
        return <Link {...props} to={path} />
      }}
    </LocaleContext.Consumer>
  }</PageContext.Consumer>
)

export default LocalizedLink